import type { NormalizedChannel } from './types'

/**
 * The GraphQL channel shape this mapper reads. Kept structural (not tied to a
 * specific consumer's fragment) so the mapper stays generic and free of import
 * cycles; a fragment's `ResultOf` selecting these fields is assignable to it.
 */
export type GraphQLChannel = {
  id: string
  type: string
  name: string
  service: string
  avatar: string | null
  serverUrl: string | null
  timezone: string | null
  locationData: { location: string | null } | null
}

/**
 * Maps a GraphQL channel fragment to the normalized format
 * Used by FilterByChannel and other GraphQL-based components
 */
export function mapGraphQLChannelToNormalized(
  channel: GraphQLChannel,
): NormalizedChannel {
  return {
    id: channel.id,
    name: channel.name,
    service: channel.service,
    avatar: channel.avatar || null,
    locationData: channel.locationData?.location ?? undefined,
    serverUrl: channel.serverUrl ?? undefined,
    serviceType: channel.type,
  }
}

/**
 * Maps a Redux/legacy channel to the normalized format
 * Used by ChannelSelector (composer)
 */
export interface ShimLegacyChannel {
  id: string
  service: {
    formattedUsername: string
  }
  serviceName: string
  serviceType: string
  images: {
    avatar: string | null
  }
  locationData?: string
  serverUrl: string | null
  isFake?: boolean
}

export function mapReduxChannelToNormalized(
  channel: ShimLegacyChannel,
): NormalizedChannel {
  return {
    id: channel.id,
    name: channel.service.formattedUsername,
    service: channel.serviceName,
    avatar: channel.images.avatar || null,
    locationData: channel.locationData,
    serverUrl: channel.serverUrl ?? undefined,
    serviceType: channel.serviceType,
  }
}
